export default "__VITE_ASSET__CO3GB86h__"